export const API_REQUEST_MUTATION_KEY = 'api-request' as const;
